import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { api } from "@/lib/api";
import "./DiscordJoinNotice.css";

export default function DiscordJoinNotice({ config, compact = false, registerTo }) {
  const [remote, setRemote] = useState({ loading: true, invite_url: null });
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    if (config !== undefined) return undefined;
    let active = true;
    setRemote({ loading: true, invite_url: null });
    api.get("/auth/discord/config")
      .then(({ data }) => { if (active) setRemote({ ...data, loading: false }); })
      .catch(() => { if (active) setRemote({ loading: false, invite_url: null }); });
    return () => { active = false; };
  }, [config, attempt]);

  const discord = config ?? remote;
  const invite = /^https:\/\/(?:www\.)?(?:discord\.gg|discord\.com\/invite)\/[A-Za-z0-9-]+\/?$/.test(discord.invite_url || "") ? discord.invite_url : null;

  return (
    <aside className={`discord-join-notice${compact ? " discord-join-notice--banner" : ""}`} aria-label="Rejoindre la communauté Discord" data-testid="discord-join-notice">
      <div className="discord-join-notice__copy">
        <MessageCircle size={23} aria-hidden="true" />
        <div>
          <p className="discord-join-notice__title">Rejoindre le Discord est obligatoire.</p>
          <p>Tu découvres DayOne FC ? Rejoins le serveur, puis lie ton compte Discord pour créer ton compte et participer à la carrière.</p>
        </div>
      </div>
      <div className="discord-join-notice__actions">
        {invite ? (
          <a href={invite} target="_blank" rel="noopener noreferrer" className="discord-join-notice__join" data-testid="discord-join-link">
            Rejoindre le Discord <span className="sr-only">(nouvel onglet)</span>
          </a>
        ) : (
          <p className="discord-join-notice__status" role="status">
            {discord.loading ? "Chargement de l’invitation…" : "Le lien d’invitation est momentanément indisponible."}
            {!discord.loading && config === undefined && <button type="button" onClick={() => setAttempt(value => value + 1)}>Réessayer</button>}
          </p>
        )}
        {registerTo && <Link to={registerTo} className="discord-join-notice__register">Puis créer mon compte</Link>}
      </div>
    </aside>
  );
}
